import i18next from 'i18next';

import CloneCatalogList from '../components/CloneCatalogList';

import { getCatalogPickerModal } from './getCatalogPickerModal';

/**
 * Fullscreen modal hosting the (modal-agnostic) CloneCatalogList. Save stays disabled until a
 * source client is picked. `excludedClientId` drops a client from the sources — used by the catalog
 * administration so a client cannot be picked as the source of its own catalog.
 */
export const getCloneCatalogModal = ({
  stores,
  selectedClientId,
  excludedClientId = null,
  onSelectClient,
  onCancel,
  onConfirm,
}) =>
  getCatalogPickerModal({
    title: i18next.t('EXTERNAL_CLIENTS.CREATION.CLONE_MODAL_TITLE'),
    icon: '/images/inpulse/clone-black.svg',
    component: CloneCatalogList,
    data: { stores, selectedClientId, excludedClientId, onSelectClient },
    isConfirmDisabled: !selectedClientId,
    onCancel,
    onConfirm,
  });
